export default {
  path: '/personnel',
  component: () => import(/* webpackChunkName: 'layout' */'@/views/personnel/layout/index'),
  meta: { requiresAuth: true },
  children: [
    {
      path: '',
      name: 'personnel',
      component: () => import(/* webpackChunkName: 'user' */'@/views/personnel/index')
    }
  ]
}
